var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSemiCircleGroupDesktop = function SvgSemiCircleGroupDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 176,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 175.53C3 122.285 45.7 79 98.223 79c52.523 0 95.222 43.285 95.222 96.53H3ZM0 69c0-13.236 10.764-24 24-24s24 10.764 24 24H0ZM146.043 0c0 24.515-19.649 44.626-44.021 44.626C77.649 44.626 58 24.707 58 0h88.043Z",
    fill: "#1279B4",
    fillOpacity: 0.05
  })));
};

export default SvgSemiCircleGroupDesktop;